import * as React from 'react';
import { Table, TableResponsive } from '@app/src/components/Table';
import {
  Wrapper,
  MainTitle,
  Content,
  Title,
  Text,
  Cell,
  ItemTable,
  State,
  WrapperPaginator,
  UserCounter,
  Space,
  EditIcon,
  EditIconResponsive
} from './styled';
import { STATE } from './constants';
import { useResize } from './hooks/useResize';
import { Pagination } from '@app/src/components/Pagination';
import { useHistory } from 'react-router-dom';
import { decodeAccessToken } from '@app/src/helpers/decodeAccessToken';

export const Container: React.FC<any> = ({
  url,
  items = [],
  isFetching,
  totalPages,
  page,
  getTotalRow,
  getPage,
  handleGetIdUser,
  valuesForm
}) => {

  const isResponsive = useResize(1280);
  const userId = decodeAccessToken('idUser');
  const history = useHistory();
  const handleClick = (idUser) => {
    handleGetIdUser(idUser);
    history.push('/usuarios/editar');
  };

  return (
    <>
      <Wrapper>
        {isResponsive ?
          <TableResponsive>
            <TableResponsive.Header>
              <MainTitle left>Nombre</MainTitle>
              <State>Estado</State>
            </TableResponsive.Header>
            {(items.length === 0 && !isFetching)
              ? (<TableResponsive.Body>
                  <TableResponsive.Main>
                    <Content>No se encontraron resultados</Content>
                  </TableResponsive.Main>
                </TableResponsive.Body>)
              : items.map((item, index) => (
                <TableResponsive.Body key={index}>
                  <TableResponsive.Main>
                    <MainTitle left>{item.fullName}</MainTitle>
                    <State>{STATE[item.state]}</State>
                  </TableResponsive.Main>
                  <TableResponsive.Content
                    renderComponent={<EditIconResponsive onClick={() => handleClick(item.userId)}>
                      <EditIcon name="edit" color="black" size="16px" />
                      Editar usuario
                    </EditIconResponsive>}
                  >
                    <Cell>
                      <Title>Correo Electrónico</Title>
                      <Text>{item.email}</Text>
                    </Cell>
                    <Cell>
                      <Title>Rol</Title>
                      <div>{item.role}</div>
                    </Cell>
                  </TableResponsive.Content>
                </TableResponsive.Body>
            ))}
          </TableResponsive>
          :
          <Table>
            <Table.Head>
              <Table.Row>
                <Table.Cell>Nombre</Table.Cell>
                <Table.Cell>Correo Electrónico</Table.Cell>
                <Table.Cell>Estado</Table.Cell>
                <Table.Cell>Rol</Table.Cell>
                <Space></Space>
              </Table.Row>
            </Table.Head>
            <Table.Body>
            {(items.length === 0 && !isFetching)
              ? (<Table.Row>
                  <Content>No se encontraron resultados</Content>
                </Table.Row>)
              : items.map((item, index) => (
                <Table.Row key={index}>
                  <ItemTable>{item.fullName}</ItemTable>
                  <ItemTable>{item.email}</ItemTable>
                  <ItemTable>{STATE[item.state]}</ItemTable>
                  <ItemTable>{item.role}</ItemTable>
                  <ItemTable>
                    <EditIcon name="edit" color="black" size="16px" onClick={() => handleClick(item.userId)} />
                  </ItemTable>
                </Table.Row>
            ))}
            </Table.Body>
          </Table>
        }
      </Wrapper>
      {page <= totalPages && (
        <WrapperPaginator>
          <UserCounter>{items.length} Usuarios de {getTotalRow}</UserCounter>
          <Pagination
            totalPages={totalPages}
            defaultPage={page}
            onClickFirstPage={(page) => getPage(page, {userId, state:1, ...valuesForm}, url)}
            onClickPrevPage={(page) => getPage(page, {userId, state:1, ...valuesForm}, url)}
            onClickNextPage={(page) => getPage(page, {userId, state:1, ...valuesForm}, url)}
            onClickLastPage={(page) => getPage(page, {userId, state:1, ...valuesForm}, url)}
            onClickCurrentPage={(page) => getPage(page, {userId, state:1, ...valuesForm}, url)}
          />
        </WrapperPaginator>

      )}
  </>
  )
};
